export const IconGrayShowEye: {
  name: 'icon_gray_show_eye-991567b3d6f9'
} = {
  name: 'icon_gray_show_eye-991567b3d6f9'
}
